import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  TextField,
  Box,
  Button,
} from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { East, West } from "@mui/icons-material";

const ProcessSection = ({
  cropName,
  handleNext,
  handleBack,
  emissionFactors,
  totalProcessEmission,
  setTotalProcessEmission,
}) => {
  const [processElectricity, setProcessElectricity] = useState(null);
  const [sterlizationElectricity, setSterlizationElectricity] = useState(null);
  const [pomeElectricity, setPomeElectricity] = useState(null);
  const [processType, setProcessType] = useState("");
  const [totalEmission, setTotalEmission] = useState(null);

  useEffect(() => {
    const calculateEmission = () => {
      console.log("before:", totalEmission);
      console.log(emissionFactors);
      let result = 0;

      if (
        !emissionFactors.Process ||
        !emissionFactors.Process.Electricity_used
      ) {
        result = 0;
      } else {
        result =
          emissionFactors.Process.Electricity_used * processElectricity +
          emissionFactors.Process.Sterlization * sterlizationElectricity;
      }

      setTotalEmission(result);
      setTotalProcessEmission(result);
    };
    calculateEmission();
  }, [processElectricity, sterlizationElectricity, pomeElectricity]);

  setTotalProcessEmission(totalEmission);
  console.log("final", totalProcessEmission);

  return (
    <Grid
      container
      fullWidth
      justifyContent="center"
      mx="auto"
      my="20%"
      borderRadius={4}
      p={3}
      xs={12}
      style={{
        boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
        background:
          "linear-gradient(to right bottom, #ffffff, #fdfdfe, #fafbfd, #f7f9fb, #f3f7fa",
      }}
    >
      <Grid item xs={12} flex>
        <Typography mb={4} variant="h4">
          Processing
        </Typography>
      </Grid>

      <Grid container xs={12} flex fullWidth>
        <Grid item xs={12} md={6} py={2} px={4}>
          <Typography variant="h6">Processing type</Typography>
          <Box mt={2}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Processing</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                value={processType}
                label="Processing"
                onChange={(e) => {
                  setProcessType(e.target.value);
                }}
              >
                <MenuItem value={"Modern"}>Modern</MenuItem>
                <MenuItem value={"Traditional"}>Traditional</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} py={2} px={4}>
          <Typography variant="h6">Electricity consumed</Typography>
          <Box mt={2}>
            <FormControl fullWidth>
              <TextField
                label="in kWh"
                variant="outlined"
                value={processElectricity}
                onChange={(event) => {
                  setProcessElectricity(event.target.value);
                }}
              />
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} py={2} px={4}>
          <Typography variant="h6">Sterlization - Electricity used</Typography>
          <Box mt={2}>
            <FormControl fullWidth>
              <TextField
                label="in kWh"
                variant="outlined"
                value={sterlizationElectricity}
                onChange={(event) => {
                  setSterlizationElectricity(event.target.value);
                }}
              />
            </FormControl>
          </Box>
        </Grid>
        {cropName === "PalmOil" && (
          <Grid item xs={12} md={6} py={2} px={4}>
            <Typography variant="h6">POME digestion process</Typography>
            <Box mt={2}>
              <FormControl fullWidth>
                <TextField
                  label="in kWh"
                  variant="outlined"
                  value={pomeElectricity}
                  onChange={(event) => {
                    setPomeElectricity(event.target.value);
                  }}
                />
              </FormControl>
            </Box>
          </Grid>
        )}
        <Grid
          item
          flex
          xs={11}
          mx="auto"
          mb={8}
          px={4}
          sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none" } }}
        >
          <Box mx="auto">
            <Button
              variant="outlined"
              onClick={handleBack}
              startIcon={<West />}
              sx={{ mt: 1, ml: 1, width: "6rem" }}
            >
              Back
            </Button>
            <Button
              variant="contained"
              onClick={handleNext}
              endIcon={<East />}
              sx={{ mt: 1, ml: 2, width: "6rem" }}
            >
              Next
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProcessSection;
